import SliceNames from '@/state/enum';
import {
	SavedBuildsActions,
	SavedBuildsState,
} from '@/state/slices/saved-builds/typings';
import { IStore, SetState } from '@/state/slices/typings';

const savedBuildsActionsCreator = (
	set: SetState<IStore>,
): SavedBuildsActions => {
	return {
		[SliceNames.SAVED_BUILDS]: {
			setBuildCounts: (
				buildCounts: SavedBuildsState[SliceNames.SAVED_BUILDS]['buildCounts'],
			) => {
				set(
					(state) => ({
						...state,
						[SliceNames.SAVED_BUILDS]: {
							...state[SliceNames.SAVED_BUILDS],
							buildCounts,
						},
					}),
					undefined,
					{
						type: `${SliceNames.SAVED_BUILDS}/setBuildCounts`,
						buildCounts,
					},
				);
			},
			setBuildData: (
				buildData: SavedBuildsState[SliceNames.SAVED_BUILDS]['buildData'],
			) => {
				set(
					(state) => ({
						...state,
						[SliceNames.SAVED_BUILDS]: {
							...state[SliceNames.SAVED_BUILDS],
							buildData,
						},
					}),
					undefined,
					{
						type: `${SliceNames.SAVED_BUILDS}/setBuildData`,
						buildData,
					},
				);
			},
		},
	};
};

export default savedBuildsActionsCreator;
